module.exports = __webpack_public_path__ + "img/evolve-pic-5.4a1b37d5.jpg";